import { useQuery } from '@tanstack/react-query';
import { ambientApi } from 'src/services';
import { PractitionerSettings } from 'src/models';
import { UseQueryOverrideOptions } from '../common';

type GetSuperadminPractitionerSettingsResponse = PractitionerSettings;

type GetSuperadminPractitionerSettingsParams = {
  practitioner_id?: number;
  headers?: Record<string, string>;
};

export const useGetSuperadminPractitionerSettings = (
  params: GetSuperadminPractitionerSettingsParams = {},
  options: UseQueryOverrideOptions<GetSuperadminPractitionerSettingsResponse> = {}
) => {
  const { practitioner_id, headers } = params;
  const orgUuid = headers?.['Impersonate-Org-UUID'] ?? null;

  return useQuery({
    ...options,
    queryKey: practitioner_id
      ? ['superadminPractitionerSettings', orgUuid, practitioner_id]
      : ['superadminPractitionerSettings', orgUuid],
    queryFn: () =>
      ambientApi
        .get<GetSuperadminPractitionerSettingsResponse>(
          '/practitioners/settings/superadmin',
          {
            params: practitioner_id ? { practitioner_id } : undefined,
            headers,
          }
        )
        .then((res) => res.data),
  });
};
